import React from 'react';
import { Modal, Radio, Space, Spin } from "antd";
import { COLORS } from './utils/Constants';
import { updateIdentityApi } from './utils/ApiUtils';
import ProcessButton from './buttons/ProcessButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPencilAlt, faMoneyBillWave, faUniversity } from '@fortawesome/free-solid-svg-icons';

const yellowColor = '#BD9806', redColor = '#FF8888';
let currentVal = 0;
const stateArray = ["Passed", "Pending", "Rejected"];

export default class IdentityModal extends React.Component {

  constructor(props) {
    super(props);
    console.log('currentObj='+JSON.stringify(props.currentObj));
    let matchStatus = props.currentObj.identityMatchStatusId;
    currentVal = matchStatus==5 ? 1 : (matchStatus==6 ? 3 : 2);
    this.state = { visible: true, loader: false, radioValue: currentVal, message: '' };
  }  

  setModalVisible = () => {
    this.setState({ loader: false, visible: false }, () => {
      this.props.closeIdModal();
    });
  }

  applyChanges = () => {
      let newValue = this.state.radioValue;
      console.log('newValue='+newValue+' old='+currentVal);
      if(newValue==currentVal) {
        this.setModalVisible();
      } else if(newValue==2) {
        this.setState({ loader: false, message: 'You cannot set state to Pending.' });
      } else {
        this.setState({ loader: true });
        updateIdentityApi(this.props.sessionValue, this.props.currentObj.id, stateArray[newValue-1])
        .then(response => {
            if(response.ok) {
                console.log('Identity updated='+JSON.stringify(response.info));
                this.props.updateSingleIdentity(response.info);
                this.setModalVisible();
            } else {
                this.setState({ loader: false, message: 'Api failed.' });
                console.log('Identity update failed='+JSON.stringify(response.info));
            }          
        })
        .catch((error) => {
            console.log('Error getting Identities List='+JSON.stringify(error));
            this.setState({ loader: false, message: 'Api failed!' });
        });
      }
  }

  onChangeRadio = e => {
    let key = e.target.value;
    console.log('radio4 checked key='+key);
    this.setState({ radioValue: key });
  }

  render() {
    let isMobile = window.innerWidth<768;
    let { visible, radioValue, loader, message } = this.state;

    return (
      <Modal
        width={384} 
        maskClosable={false}
        visible={visible}
        centered={isMobile ? true : false}
        closeIcon={<FontAwesomeIcon icon={faTimes} style={{ color: yellowColor, marginTop: 48, fontSize: 20 }} />}
        bodyStyle={{ top: isMobile ? '10%' : '0%', height: 540, padding: 0, backgroundColor: COLORS.white }}
        onOk={() => this.setModalVisible(false)}
        onCancel={() => this.setModalVisible(false)}
        footer={null}
      >
        <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column', padding: 4, 
        backgroundColor: yellowColor }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent:'center', 
          height: '100%', backgroundColor: COLORS.blue2a3a4a }}>
            <Radio.Group onChange={this.onChangeRadio} size='large' defaultValue={radioValue} 
            buttonStyle="solid" style={{ marginTop: 100 }}>
                <Space direction="vertical">
                    <Radio.Button className="rad1 radioNew" value={1} style={{ width: 144 }}>
                        <FontAwesomeIcon className="rad1" icon={faPencilAlt} style={{ fontSize: 16, marginRight: 12 }} />
                        Passed
                    </Radio.Button>
                    <Radio.Button className="rad3 radioNew" value={2} style={{ width: 144 }}>
                        <FontAwesomeIcon className="rad3"  icon={faUniversity} style={{ fontSize: 16, marginRight: 12 }} />
                        Pending
                    </Radio.Button>
                    <Radio.Button className="rad2 radioNew" value={3} style={{ width: 144 }}>
                        <FontAwesomeIcon className="rad2"  icon={faMoneyBillWave} style={{ fontSize: 16, marginRight: 12 }} />
                        Rejected
                    </Radio.Button>
                </Space>
            </Radio.Group>
            <div style={{ marginTop: 100 }}>
                <ProcessButton text="Apply Changes" bgColor={yellowColor}
                onClick={()=>{this.applyChanges()}} />
            </div>
            <div style={{ height: 20, fontSize: 10, fontFamily: 'OpenSans-SemiBold', color: redColor, textAlign: 'center', marginTop: 6 }}>
                {message}
            </div>
          </div>
        </div>
        { loader &&
            <div style={{ position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center',
            top: 0, left: 0, width: '100%', height: '100%', zIndex: 11, backgroundColor: 'rgba(10, 26, 42, 0.6)' }}>
                <Spin size='large' />
            </div>
        }
      </Modal>
  );
  }
}
